import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForProductWorkComponent extends Component {
  // Defaults
  defaultColumns = ['id', 'name', 'cmsState', 'cmsModified'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'name',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'workContributors',
      relationPath: 'artist',
      relationLabel: 'artist.displayLabel',
      type: 'relation',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
